import { AxiosResponse } from "axios";
import {
  GameQuizEntity,
  GameQuizEntityInput,
  GameQuizReuploadImpact,
  SearchGameQuizParams,
  PaginatedGameQuizzesResponse,
} from "./gameQuiz.types";
import { api } from "../api";

const emptyResponse: PaginatedGameQuizzesResponse = {
  data: [],
  total: 0,
  page: 1,
  pageSize: 10,
  totalPages: 0,
};

export const getGameQuizzes = async (params?: SearchGameQuizParams) => {
  try {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append("page", params.page.toString());
    if (params?.pageSize)
      searchParams.append("pageSize", params.pageSize.toString());
    if (params?.search) searchParams.append("search", params.search);
    if (params?.published !== undefined)
      searchParams.append("published", String(params.published));

    const url = `/game-quizzes${
      searchParams.toString() ? `?${searchParams.toString()}` : ""
    }`;
    const response: AxiosResponse<PaginatedGameQuizzesResponse> = await api.get(
      url,
    );
    return response.status === 200 ? response.data : emptyResponse;
  } catch (error) {
    console.error(error);
    return emptyResponse;
  }
};

export const getGameQuizById = async (id: number) => {
  try {
    const response: AxiosResponse<GameQuizEntity> = await api.get(
      `/game-quizzes/${id}`,
    );
    return response.status === 200 ? response.data : null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const createGameQuiz = async (data: GameQuizEntityInput) => {
  try {
    const response: AxiosResponse<GameQuizEntity> = await api.post(
      "/game-quizzes",
      data,
    );
    return response.status === 201 ? response.data : null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const updateGameQuiz = async (
  id: number,
  data: Partial<GameQuizEntityInput>,
) => {
  try {
    const response: AxiosResponse<GameQuizEntity> = await api.patch(
      `/game-quizzes/${id}`,
      data,
    );
    return response.status === 200 ? response.data : null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const deleteGameQuiz = async (id: number) => {
  try {
    const response: AxiosResponse<GameQuizEntity> = await api.delete(
      `/game-quizzes/${id}`,
    );
    return response.status === 200 ? response.data : null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// Unlike the calls above, a failure rejects: the caller must not read it as
// "nothing reached" and re-upload a YAML without the warning.
export const getGameQuizReuploadImpact = async (
  id: number,
): Promise<GameQuizReuploadImpact> => {
  const response: AxiosResponse<GameQuizReuploadImpact> = await api.get(
    `/game-quizzes/${id}/reupload-impact`,
  );
  return response.data;
};
